"use client";

import styles from "./TextWithSubheading.module.css";
import MaxWidth from "@/components/MaxWidth";
import { Header3, Header2 } from "@bumble/ui-kit";
interface Props {
  subheading?: string;
  text?: string;
}
export default function TextWithSubheading({
  subheading,
  text
}: Props) {
  if (!subheading && !text) {
    return null;
  }
  return <MaxWidth>
      <section className={styles.wrapper}>
        {subheading ? <Header3>{subheading}</Header3> : null}
        {text ? <Header2>{text}</Header2> : null}
      </section>
    </MaxWidth>;
}